import React from "react";
import { Container, Button, Col, Row } from "react-bootstrap";
import moment from "moment";
const Details = ({ details, goBack }) => {
    const {
        date,
        title,
        text,
        people,
        locations,
        events,
        dates,
        summary,
        learnMore,
        imageUrl
    } = details;

    return (
        <Container>
            <h1 className="display-3 pb-4 text-center">{title}</h1>
            <Row>
                <Col>
                    <img
                        src={imageUrl}
                        alt={`Image of ${title}`}
                        style={{ width: "100%" }}
                    />
                </Col>
                <Col>
                    <p className="mt-3">
                        <strong>Date: </strong>
                        {moment(date).format("MM/DD/YYYY")}
                    </p>
                    <p className="mt-3">
                        <strong>Main Idea: </strong>
                        {summary}
                    </p>
                    <p className="mt-3">
                        <strong>The Whole Story: </strong>
                        {text}
                    </p>
                    <div className="mt-3">
                        <p>
                            <strong>People: </strong>
                        </p>
                        <ul>
                            {people.map((person, i) => (
                                <li key={i}>
                                    <a href={person.link} target="_blank">
                                        {person.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="mt-3">
                        <p>
                            <strong>Locations: </strong>
                        </p>
                        <ul>
                            {locations.map((location, i) => (
                                <li key={i}>
                                    <a href={location.link} target="_blank">
                                        {location.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="mt-3">
                        <p>
                            <strong>Events: </strong>
                        </p>
                        <ul>
                            {events.map((event, i) => (
                                <li key={i}>
                                    <a href={event.link} target="_blank">
                                        {event.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="mt-3">
                        <p>
                            <strong>Dates: </strong>
                        </p>
                        <ul>
                            {dates.map((date, i) => (
                                <li key={i}>
                                    {date.dateString} - {date.name}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <p className="mt-3">
                        <strong>Learn More: </strong>
                        {learnMore}
                    </p>
                </Col>
            </Row>
            <Row className="mb-5">
                <Button className="btn btn-dark" onClick={goBack}>
                    Go Back
                </Button>
            </Row>
        </Container>
    );
};

export default Details;
